import { SetStateAction, Dispatch } from 'react';
import '../App.css';
import '../style.css';
import { FilterItem } from './FilterItem';

function ActivitiesChipFilter(props: {
  activeFilter: number, 
  setActiveFilter: Dispatch<SetStateAction<number>>,
}) {
  
  return (
    <div className='filter'>
      <div className='filter-content'>
        <div onClick={() => props.setActiveFilter(1)} style={{cursor: 'pointer'}}>
          <FilterItem isSelected={props.activeFilter === 1} name='All' />
        </div>  
        <div onClick={() => props.setActiveFilter(2)} style={{cursor: 'pointer'}}>
          <FilterItem isSelected={props.activeFilter === 2} name='Creative' />
        </div>
        <div onClick={() => props.setActiveFilter(3)} style={{cursor: 'pointer'}}>
          <FilterItem isSelected={props.activeFilter === 3} name='Book Report' />
        </div>
        <div onClick={() => props.setActiveFilter(4)} style={{cursor: 'pointer'}}>
          <FilterItem isSelected={props.activeFilter === 4} name='Essay' />
        </div>
        <div onClick={() => props.setActiveFilter(5)} style={{cursor: 'pointer'}}>
          <FilterItem isSelected={props.activeFilter === 5} name='2026' />
        </div>
        <div onClick={() => props.setActiveFilter(6)} style={{cursor: 'pointer'}}>
          <FilterItem isSelected={props.activeFilter === 6} name='2025' />
        </div>
        <div onClick={() => props.setActiveFilter(7)} style={{cursor: 'pointer'}}>
          <FilterItem isSelected={props.activeFilter === 7} name='2024' />
        </div> 
      </div>
    </div>
  );
}

export default ActivitiesChipFilter;
